import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';
import qs from 'querystring';

import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import { ENUM_STUDIO_STATUS } from 'enum/profile';

import { GET_STUDIO_INVITATION_STATUS } from './Api';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

const SET_STUDIO_INVITATION_FETCHING_STATUS = 'cam4/studio/SET_STUDIO_INVITATION_FETCHING_STATUS';
const SET_STUDIO_INVITATION_STATUS = 'cam4/studio/SET_STUDIO_INVITATION_STATUS';
const UPDATE_STUDIOS = 'cam4/studio/UPDATE_STUDIOS';

export const NAME = 'studios';

const initialState = Immutable.fromJS({
  studios: [],
  studioInvitationStatus: {},
  isFetching: true,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_STUDIOS:
      return state.set('studios', action.studio);

    case SET_STUDIO_INVITATION_STATUS:
      return state.set('studioInvitationStatus', action.status);

    case SET_STUDIO_INVITATION_FETCHING_STATUS:
      return state.set('isFetching', action.isFetching);

    default:
      return state;
  }
}

const studios = (state) => state[NAME].get('studios');
const studioInvitationStatus = (state) => state[NAME].get('studioInvitationStatus');
const isFetching = (state) => state[NAME].get('isFetching');

function updateStudios(studio) {
  return {
    type: UPDATE_STUDIOS,
    studio,
  };
}

function updateStudioInvitationStatus(status) {
  return {
    type: SET_STUDIO_INVITATION_STATUS,
    status,
  };
}

function updateFetchingStatus(isFetching) {
  return {
    type: SET_STUDIO_INVITATION_FETCHING_STATUS,
    isFetching,
  };
}

function getStudioInvitationStatus(studioOwnerName, performerUsername) {
  const URL = GET_STUDIO_INVITATION_STATUS.replace('{studioOwnerName}', encodeURIComponent(studioOwnerName)).replace(
    '{performerUsername}',
    encodeURIComponent(performerUsername)
  );

  return (dispatch) =>
    ApiService
      .get(URL)
      .then((res) => {
        dispatch(updateFetchingStatus(false));
        dispatch(updateStudioInvitationStatus(res.data));
      })
      .catch(() => {
        dispatch(updateFetchingStatus(false));
        dispatch(updateStudioInvitationStatus(ENUM_STUDIO_STATUS.ERROR));
      });
}

function addStudioToList(studioName, url, callback) {
  const URL = BASE_URL + url; // eslint-disable-line no-undef
  const config = {
    data: qs.stringify({ status: ENUM_STUDIO_STATUS.CONFIRMED }),
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
  };

  return (dispatch) =>
    ApiService
      .put(URL, config)
      .then(() => {
        callback(true);

        return dispatch(updateStudios(studioName));
      })
      .catch(() => {
        callback(false);
      });
}

export const selector = createStructuredSelector({
  studios,
  studioInvitationStatus,
  isFetching,
});

export const actionCreators = {
  addStudioToList,
  getStudioInvitationStatus,
};
